import { render, staticRenderFns } from "./EditFooterNewChic.vue?vue&type=template&id=5dcf8255&scoped=true&"
import script from "./EditFooterNewChic.vue?vue&type=script&lang=js&"
export * from "./EditFooterNewChic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dcf8255",
  null
  
)

export default component.exports